import { HttpErrorResponse } from "@angular/common/http";
import type { ErrorEvent, EventHint } from "@sentry/browser";

// Sentry's browserApiErrors wrapper captures an HttpErrorResponse thrown from
// an async task as a plain object before Angular sees it. The rethrow still
// reaches SentryErrorHandler, which reports it as a proper Error, so the raw
// capture is a duplicate with no useful stack.
export function sentryBeforeSend(
  event: ErrorEvent,
  hint: EventHint,
): ErrorEvent | null {
  return hint.originalException instanceof HttpErrorResponse ? null : event;
}
